import React, { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { useNavigate } from "react-router-dom";

import { auth } from "../firebase/firebase";

function AdminLogin() {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [showPassword, setShowPassword] = useState(false);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();

    setError("");

    if (!email.trim() || !password) {
      setError("Please enter your email and password.");
      return;
    }

    try {
      setLoading(true);

      await signInWithEmailAndPassword(
        auth,
        email.trim(),
        password
      );

      navigate("/admin/gallery");

    } catch (error) {
      console.error("LOGIN ERROR:", error);

      switch (error.code) {
        case "auth/invalid-credential":
          setError("Incorrect email or password.");
          break;

        case "auth/user-not-found":
          setError("This email is not registered.");
          break;

        case "auth/wrong-password":
          setError("Incorrect password.");
          break;

        case "auth/invalid-email":
          setError("Invalid email address.");
          break;

        case "auth/operation-not-allowed":
          setError(
            "Email/Password login is not enabled in Firebase."
          );
          break;

        default:
          setError(error.message);
      }

    } finally {
      setLoading(false);
    }
  };

  return (
    <main
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "30px",
        background: "#eee5dc",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "430px",
          padding: "45px 35px",
          background: "rgba(255,255,255,0.85)",
          borderRadius: "20px",
          boxShadow: "0 20px 60px rgba(0,0,0,0.12)",
        }}
      >

        {/* ================= HEADER ================= */}

        <div
          style={{
            textAlign: "center",
            marginBottom: "30px",
          }}
        >
          <img
            src="https://i.postimg.cc/B6xbCvXC/Logo-ph.jpg"
            alt="Logo"
            style={{
              width: "75px",
              height: "75px",
              borderRadius: "50%",
              objectFit: "cover",
              marginBottom: "15px",
            }}
          />

          <span
            style={{
              display: "block",
              fontSize: "11px",
              letterSpacing: "2px",
              color: "#9a765d",
              marginBottom: "8px",
            }}
          >
            PRIVATE STUDIO
          </span>

          <h1
            style={{
              margin: 0,
              color: "#4a3b32",
            }}
          >
            Admin Login
          </h1>

          <p
            style={{
              color: "#806c5c",
              fontSize: "13px",
            }}
          >
            Sign in to manage your gallery.
          </p>
        </div>

        {/* ================= FORM ================= */}

        <form onSubmit={handleLogin}>

          {/* EMAIL */}

          <label
            style={{
              display: "block",
              marginBottom: "7px",
              color: "#4a3b32",
            }}
          >
            Email
          </label>

          <input
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={{
              width: "100%",
              boxSizing: "border-box",
              padding: "14px",
              marginBottom: "20px",
              border: "1px solid #d8c9bb",
              borderRadius: "10px",
              outline: "none",
            }}
          />

          {/* PASSWORD */}

          <label
            style={{
              display: "block",
              marginBottom: "7px",
              color: "#4a3b32",
            }}
          >
            Password
          </label>

          {/* PASSWORD WRAPPER */}

          <div
            style={{
              position: "relative",
              width: "100%",
              marginBottom: "15px",
            }}
          >

            <input
              type={showPassword ? "text" : "password"}
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={{
                width: "100%",
                boxSizing: "border-box",
                padding: "14px 45px 14px 14px",
                border: "1px solid #d8c9bb",
                borderRadius: "10px",
                outline: "none",
              }}
            />

            {/* EYE BUTTON */}

            <button
              type="button"
              onClick={() =>
                setShowPassword(!showPassword)
              }
              aria-label={
                showPassword
                  ? "Hide password"
                  : "Show password"
              }
              style={{
                position: "absolute",
                right: "12px",
                top: "50%",
                transform: "translateY(-50%)",
                border: "none",
                background: "transparent",
                cursor: "pointer",
                fontSize: "18px",
                color: "#806c5c",
                padding: "5px",
              }}
            >
              {showPassword ? "🙈" : "👁️"}
            </button>

          </div>

          {/* ERROR */}

          {error && (
            <p
              style={{
                color: "#b04a4a",
                fontSize: "13px",
                marginBottom: "15px",
              }}
            >
              {error}
            </p>
          )}

          {/* LOGIN BUTTON */}

          <button
            type="submit"
            disabled={loading}
            style={{
              width: "100%",
              padding: "15px",
              border: "none",
              borderRadius: "10px",
              background: "#4a3b32",
              color: "white",
              cursor: loading
                ? "not-allowed"
                : "pointer",
              fontSize: "14px",
              opacity: loading ? 0.7 : 1,
            }}
          >
            {loading ? "Signing in..." : "Sign In"}
          </button>

        </form>

      </div>
    </main>
  );
}

export default AdminLogin;